import { render, staticRenderFns } from "./PurchasesExpensesPeriods.vue?vue&type=template&id=4a088e82&scoped=true"
import script from "./PurchasesExpensesPeriods.vue?vue&type=script&lang=js"
export * from "./PurchasesExpensesPeriods.vue?vue&type=script&lang=js"
import style0 from "./PurchasesExpensesPeriods.vue?vue&type=style&index=0&id=4a088e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a088e82",
  null
  
)

export default component.exports